import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../settings/withDirection';

const CountElement = styled.div`
  align-items: center;
  background-color: ${palette('primary', 0)};
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-family: 'Helvetica';
  font-size: 10px;
  font-weight: 900;
  height: 16px;
  justify-content: center;
  line-height: 20px;
  padding-left: 1px;
  position: absolute;
  top: -6px;
  right: ${props => (props['data-rtl'] === 'rtl' ? 'initial' : '-10px')};
  left: ${props => (props['data-rtl'] === 'rtl' ? '-8px' : 'initial')};
  text-align: center;
  width: 16px;

  &.is-max-amount {
    font-size: 9px !important;
  }
`;

export const CountWrapper = WithDirection(CountElement);
